// Ugly hackpack for KudaGo.com
// There are temporary fixes of layout here, 
// and we'll delete it after KG team will deploy own methods.

export function fixKudaGoLayout () {
    document.querySelectorAll('.post-big-text').forEach((element) => element.style.overflow = "unset")
} 

export function isLayoutMobile () {
    const kgParams = window.kudago
    if (!kgParams) return "auto"
    return (kgParams.flavour === "mobile") ? "true" : "false"
}